import React, { FC, useEffect, useState } from "react";
import moment from "moment";
import Modal from "react-bootstrap/Modal";
import "./net-rates.scss";

import { useAppSelector, useAppDispatch } from "../../app/hooks";
import { fetchNetRates, fetchNetRatesStatus, updateNetRatesStatus, clubsActions } from "../../reducers/clubsSlice";
import { DiscountRequestPayload } from "../../models/discountRequest";
import CommonHeader from "../../shared/common-header/common-header";
import { INTEGOLF_DISCOUNT_REQUEST_STATUS_REQUESTED, SAGA_STATUS_FAILED, SAGA_STATUS_SUCCESS } from "../../utils/constants";
import { useTranslation } from "react-i18next";
import TeeTimeRates from "./tee-time-rates";
import { toast } from "react-toastify";

interface NetRatesProps {}

const NetRates: FC<NetRatesProps> = () => {
  
    const dispatch = useAppDispatch();
    const {t}=useTranslation("")
    const netRates: Array<DiscountRequestPayload> = useAppSelector(fetchNetRates);
    const processNetRatesStatus: string = useAppSelector(fetchNetRatesStatus);
    const updateNetRatesStatusData:any = useAppSelector(updateNetRatesStatus);


    useEffect(() => {
        dispatch(clubsActions.netRatesList());
        if(updateNetRatesStatusData==="success"){
            toast.success("Net rates updated!");
            dispatch(clubsActions.resetNetRatesClub())
        }
    }, [updateNetRatesStatusData])

    function handleNetRateUpdate(data:any){
        dispatch(clubsActions.updateNetRates(data))
    }

    return (
        <div className="discountRequestsListWrapper">
            <CommonHeader 
                sectionTitle={t("NetRatePage.title")} 
                //sectionTitle={t("DiscountsRequestsPage.DiscountRequests")}
            />
            <div className="container">
                <div className="row">
                    <TeeTimeRates netRates={netRates} handleNetRateUpdate={handleNetRateUpdate}/>
                </div>

            </div>
           
        </div>
    );
};

export default NetRates;
